import { Box, Typography } from '@mui/material'
import { useI18n, useRouter } from '@popety_io/popety-io-lib'
import { useDispatch, useSelector } from 'react-redux'
import { downloadFile, estimateSelector } from '../../../redux'
import EstimateFileItem from './FileItem'
import { FileProps } from './types'

const EstimateFiles = () => {
  const dispatch = useDispatch()
  const estimate = useSelector(estimateSelector)
  const { t } = useI18n()
  const { query } = useRouter()
  const { hash } = query

  const handleDlFile = (fileId: FileProps['id']) => {
    dispatch(downloadFile({ hash, fileId }) as any)
  }

  return (
    <Box
      sx={{
        marginTop: '20px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
            color: (theme) => theme.palette.secondary.main,
          }}
        >
          {t('common.files')}
        </Typography>
      </Box>
      {estimate.files.map((file: FileProps) => (
        <EstimateFileItem file={file} handleDlFile={handleDlFile} />
      ))}
    </Box>
  )
}

export default EstimateFiles
